/* =====================================================
   assets/timeline-our-story-2026.js
   NuFace 2026 Redesign — Our Story timeline slide pager
   KC 2026-06-18

   Loaded only when the section has 2+ slides. The heading lives
   outside the slides and never moves; arrows toggle which slide is
   active (.is-active) — no re-render. Bounded (no wrap): the prev
   arrow disables on the first slide, next on the last.
   ===================================================== */

(function () {
  'use strict';

  function initSection(section) {
    var slides = section.querySelectorAll('[data-timeline-slide]');
    if (slides.length < 2) return;
    if (section.dataset.timelineInited === '1') return;
    section.dataset.timelineInited = '1';

    var prevBtn = section.querySelector('[data-timeline-prev]');
    var nextBtn = section.querySelector('[data-timeline-next]');
    var current = 0;

    function render() {
      for (var i = 0; i < slides.length; i++) {
        var isActive = i === current;
        slides[i].classList.toggle('is-active', isActive);
        slides[i].setAttribute('aria-hidden', isActive ? 'false' : 'true');
      }
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === slides.length - 1;
    }

    function goTo(index) {
      current = Math.max(0, Math.min(slides.length - 1, index));
      render();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')       goTo(current - 1);
      else if (e.key === 'ArrowRight') goTo(current + 1);
    });

    render();
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('.timeline-our-story-2026[data-slide-count]');
    for (var i = 0; i < sections.length; i++) {
      var count = parseInt(sections[i].dataset.slideCount, 10) || 1;
      if (count > 1) initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
